import React from "react";

const BetaIcon = ({ className = "" }) => {
  return (
    <svg
      width="32"
      height="16"
      viewBox="0 0 32 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" y="0.5" width="31" height="15" rx="3.5" stroke="#636369" />
      <path
        d="M7.87012 12H5.04297V4.9541H7.85547C8.48047 4.9541 8.98177 5.11523 9.35938 5.4375C9.73698 5.75651 9.92578 6.18132 9.92578 6.71191C9.92578 7.08626 9.80371 7.42155 9.55957 7.71777C9.31868 8.01074 9.02246 8.18652 8.6709 8.24512V8.28418C9.15267 8.33952 9.54004 8.52507 9.83301 8.84082C10.126 9.15332 10.2725 9.54232 10.2725 10.0078C10.2725 10.6296 10.0592 11.1178 9.63281 11.4727C9.20638 11.8242 8.61882 12 7.87012 12ZM6.13672 5.84766V7.95215H7.3623C7.83431 7.95215 8.19727 7.85775 8.45117 7.66895C8.70508 7.48014 8.83203 7.21159 8.83203 6.86328C8.83203 6.53776 8.72461 6.28711 8.50977 6.11133C8.29492 5.93555 7.98893 5.84766 7.5918 5.84766H6.13672ZM6.13672 11.1064H7.64551C8.13704 11.1064 8.51139 11.0072 8.76855 10.8086C9.02572 10.61 9.1543 10.3203 9.1543 9.93945C9.1543 9.17122 8.63021 8.78711 7.58203 8.78711H6.13672V11.1064ZM15.6875 11.0527V12H11.2148V4.9541H15.6875V5.89648H12.3086V7.95703H15.5068V8.86523H12.3086V11.0527H15.6875ZM19.6523 12H18.5586V5.89648H16.4004V4.9541H21.8057V5.89648H19.6523V12ZM26.3223 12L25.6777 10.0957H22.9922L22.3477 12H21.21L23.7539 4.9541H24.9355L27.4795 12H26.3223ZM24.3203 6.12598L23.2705 9.2168H25.3994L24.3496 6.12598H24.3203Z"
        fill="#636369"
      />
    </svg>
  );
};

export default BetaIcon;
